import OrderCreate from './OrderCreate';
import OrderEdit from './OrderEdit';
import OrderList from './OrderList';
import OrderShow from './OrderShow';

const orders = {
    list: OrderList,
    edit: OrderEdit,
    create: OrderCreate,
    show: OrderShow,
};

export default orders;
